import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import ErrorBoundary from '../error/error-boundary';
import { IRootState } from '../../reducers';
import { IPermission } from '../../reducers/authentication';
import { parseObj } from '../utils/utils';
import { ROUTE } from '../../config/constants';

interface IOwnProps extends RouteProps {
    permissions?: string | string[];
}
// eslint-disable-next-line @typescript-eslint/no-use-before-define
export interface IPrivateRouteProps extends IOwnProps, StateProps {}

export const PrivateRouteComponent = ({
    component: Component,
    isAuthenticated,
    isAuthorized,
    sessionHasBeenFetched,
    // hasAnyAuthorities = [],
    ...rest
}: IPrivateRouteProps) => {
    const checkAuthorities = (props) =>
        isAuthorized ? (
            <ErrorBoundary>{Component && <Component {...props} />}</ErrorBoundary>
        ) : (
            <div className="wrapper">
                <div className="clr-error">Ви не маєте права доступу до цієї сторінки.</div>
            </div>
        );

    const renderRedirect = (props) => {
        if (!sessionHasBeenFetched) {
            return <div />;
        } else {
            return isAuthenticated ? (
                checkAuthorities(props)
            ) : (
                <Redirect
                    to={{
                        pathname: ROUTE.LOGIN,
                        // search: props.location.search,
                        state: { from: props.location },
                    }}
                />
            );
        }
    };

    if (!Component) throw new Error(`A component needs to be specified for private route for path ${rest?.path}`);

    return <Route {...rest} render={renderRedirect} />;
};

export const hasAccess = (userPermission: IPermission, permissions: string | string[]): boolean => {
    const tmpPermissions = Array.isArray(permissions) ? permissions : [permissions];
    if (!permissions || !tmpPermissions?.length) {
        return true;
    }
    return tmpPermissions.some((key) => parseObj(userPermission, key));
};

const mapStateToProps = (
    { auth: { isAuthenticated, permission, sessionHasBeenFetched } }: IRootState,
    { permissions = [] }: IOwnProps,
) => ({
    isAuthenticated,
    isAuthorized: hasAccess(permission || {}, permissions),
    sessionHasBeenFetched,
});
// eslint-disable-next-line no-undef
type StateProps = ReturnType<typeof mapStateToProps>;

/**
 * A route wrapped in an authentication check so that routing happens only when you are authenticated.
 * Accepts same props as React router Route.
 * The route also checks for authorization if hasAnyAuthorities is specified.
 */
// @ts-ignore
export const PrivateRoute = connect<StateProps, undefined, IOwnProps>(mapStateToProps)(PrivateRouteComponent);

export default PrivateRoute;
